import gql from "graphql-tag";

const PUT_RULE = gql`
  mutation PutRule($rule: RuleInput!) {
    putRule(rule: $rule) {
      ruleId
    }
  }
`;

const DELETE_RULE = gql`
  mutation deleteRule($ruleId: Int!) {
    deleteRule(ruleId: $ruleId) {
      ruleId
    }
  }
`;

const SAVE_ISSUE = gql`
  mutation SaveIssue($issue: CreateIssue!) {
    saveIssue(issue: $issue) {
      id
    }
  }
`;

const PUT_USER_CLIP = gql`
  mutation PutUserClip($userClip: UserClipInput!) {
    putUserClip(userClip: $userClip) {
      id
    }
  }
`;

const SAVE_USER_CUSTOM_CLIP = gql`
  mutation PutUserCustomClip($userCustomClip: SaveUserCustomClipInput!) {
    saveUserCustomClip(userCustomClip: $userCustomClip) {
      id
    }
  }
`;

const DELETE_USER_CUSTOM_CLIP = gql`
  mutation DeleteUserCustomClip($clipId: Int!) {
    deleteUserCustomClip(clipId: $clipId) {
      success
    }
  }
`;

const CREATE_CUSTOM_CLIP = gql`
  mutation CreateCustomClip($customClipRequest: CustomClipInput!) {
    createCustomClip(customClipRequest: $customClipRequest) {
      success
      videoUrl
      thumbnailUri
    }
  }
`;

export {
  PUT_RULE,
  DELETE_RULE,
  SAVE_ISSUE,
  PUT_USER_CLIP,
  SAVE_USER_CUSTOM_CLIP,
  DELETE_USER_CUSTOM_CLIP,
  CREATE_CUSTOM_CLIP
};



// WEBPACK FOOTER //
// ./src/httpClients/graphql/sporty-mutations.js